import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import {
  Div,
  MediumOutlineButton,
  OpenInNewIcon,
  MediumFilledButton
} from "components/Base";
import { noop, withProps } from "utils/General";
import { actions, getters } from "../model";
import { TAB_IDS } from "../constants";
import {
  getBackgroundColor,
  getIsManageSessionsEnabled,
  getIsViewSessionFormEnabled
} from "Portal/NewPortal/PortalHome/selectors";
import { getFormHasChanges, getIsValid } from "../selectors";

const decorate = R.compose(
  connect(
    state => ({
      selectedTab: getters.selectedTab(state),
      sessionData: getters.sessionData(state),
      isEditingSession: getters.isEditingSession(state),
      backgroundColor: getBackgroundColor(state),
      isManageSessionsEnabled: getIsManageSessionsEnabled(state),
      isViewSessionFormEnabled: getIsViewSessionFormEnabled(state),
      saving: getters.saving(state),
      formHasChanges: getFormHasChanges(state),
      isValid: getIsValid(state),
      fieldsErrorMessage: getters.fieldsErrorMessage(state)
    }),
    {
      openSession: actions.openSession,
      enableSessionEditMode: actions.enableSessionEditMode,
      cancelSave: actions.cancel,
      save: actions.save
    }
  )
);

const Footer = ({
  saving,
  openSession = noop,
  selectedTab,
  sessionData = {},
  backgroundColor = null,
  enableSessionEditMode = noop,
  cancelSave = noop,
  isEditingSession = false,
  save = noop,
  isManageSessionsEnabled,
  formHasChanges,
  isValid,
  isViewSessionFormEnabled = true,
  fieldsErrorMessage
}) => {
  const { id = null } = sessionData || {};

  const showFooter = selectedTab === TAB_IDS.DETAILS;
  // && !sessionData.isSubsession;
  // selectedTab === TAB_IDS.FILE_CONTENT;

  if (!showFooter) {
    return null;
  }

  const hasInvalidMessage = isValid !== true && isValid.length ? true : false;

  return (
    <Div
      display="row.flex-start.center"
      style={{
        position: "absolute",
        bottom: 0,
        padding: "16px 20px",
        boxSizing: "border-box",
        borderTop: "solid 1px #E7E6EA",
        height: "68px",
        ...(backgroundColor ? { backgroundColor } : {})
      }}
      width={1}
    >
      {selectedTab === TAB_IDS.DETAILS ? (
        isManageSessionsEnabled ? (
          !isEditingSession ? (
            <MediumFilledButton
              className="accentable-primary-button"
              bg="primary7"
              mr={1.5}
              onClick={enableSessionEditMode}
              style={{
                borderWidth: "1px",
                height: "38px",
                // width: "159px",
                fontSize: "14px"
              }}
            >
              Edit
            </MediumFilledButton>
          ) : (
            <>
              <MediumOutlineButton
                mr={2}
                color="neutral7"
                bc="neutral2"
                onClick={cancelSave}
                disabled={saving}
                style={{
                  borderWidth: "1px",
                  height: "38px",
                  // width: "124px",
                  fontSize: "14px"
                }}
              >
                Cancel
              </MediumOutlineButton>
              <MediumFilledButton
                className="accentable-primary-button"
                bg="primary7"
                onClick={save}
                disabled={saving || !formHasChanges || hasInvalidMessage}
                style={{
                  borderWidth: "1px",
                  height: "38px",
                  // width: "159px",
                  fontSize: "14px"
                }}
              >
                {saving ? "Saving..." : "Save Changes"}
              </MediumFilledButton>
              {isValid !== true || fieldsErrorMessage ? (
                <Div
                  color="danger8"
                  style={{
                    width: "auto",
                    fontSize: "14px",
                    marginLeft: "22px"
                  }}
                >
                  {hasInvalidMessage ? isValid : fieldsErrorMessage}
                </Div>
              ) : null}
            </>
          )
        ) : null
      ) : (
        ""
      )}

      {selectedTab === TAB_IDS.DETAILS &&
      !sessionData.isSubsession &&
      !isEditingSession &&
      isViewSessionFormEnabled ? (
        <MediumOutlineButton
          color="neutral7"
          bc="neutral2"
          onClick={() =>
            openSession({
              id
            })
          }
          RightIcon={withProps({ size: "14" })(OpenInNewIcon)}
          style={{
            borderWidth: "1px",
            height: "38px",
            // width: "159px",
            fontSize: "14px",
            ...(backgroundColor ? { backgroundColor } : {})
          }}
        >
          View Submission
        </MediumOutlineButton>
      ) : null}
    </Div>
  );
};
export default decorate(Footer);
